import React, { useEffect, useState } from 'react';
import CenterSpinner from '../../../../general/Loadings/CenterSpinner.js';
import NameDescription from './steps/NameDescription.js';
import Conditions from './steps/Conditions.js';
import { callTokenApi } from '../../../../../apiCaller.js';
import { API_ADMIN_ACCOUNT_ENRICHMENT_RULES } from '../../../../../constants/apiRest.js';
import { toast } from 'react-toastify';
import RuleType from './steps/RuleType.js';

export const FormSetupContext = React.createContext({});

const FormSetup = ({ attributes }) => {
    const { id, accountId, enrichmentType, setEnrichmentList, setAccountEnrichment, templatePixelRule, isPixelRule } = attributes;
    const [isLoading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(id || isPixelRule ? 2 : 1);
    const [stepsData, setStepsData] = useState(templatePixelRule || {
        ruleType: '',
        name: '',
        description: '',
        conditions: [
            {
                conjunction: '',
                g0: {
                    type: 'Conversion',
                    key: '',
                    operator: 'eq',
                    value: 'true',
                    conjunction: '',
                    enrichmentType: '',
                },
            },
        ]
    });

    const [initStepsData, setInitStepsData] = useState(stepsData)
    useEffect(() => {
        const loadRuleData = async () => {
            if (!id) return;

            setIsLoading(true);
            try {
                const response = await callTokenApi(`${API_ADMIN_ACCOUNT_ENRICHMENT_RULES}/${id}`, 'GET');
                const ruleData = response?.data?.data;

                if (response?.status === 200 && ruleData) {
                    const ruleValue = {
                        id: ruleData.id,
                        name: ruleData.name,
                        description: ruleData.description,
                        ruleType: ruleData.ruleType,
                        ...ruleData?.conditions,
                    }
                    setStepsData(ruleValue);
                    setInitStepsData(ruleValue);
                } else {
                    toast.error('Failed to load rule data.');
                }
            } catch (error) {
                console.error('Fetch rule data error:', error);
                toast.error('An error occurred while loading rule data.');
            } finally {
                setIsLoading(false);
            }
        };

        loadRuleData();
    }, [id]);

    return (
        <React.Suspense fallback={<CenterSpinner />}>
            <div className="rule-detail">
                {isLoading ? (
                    <CenterSpinner />
                ) : (
                    <div className="cvr-create-new">
                        <h1 className='mb-0'>
                            {!id && !isPixelRule ? `Create ${stepsData.ruleType || 'a Rule'}` : `Edit ${stepsData.ruleType}: ${stepsData.name}`}
                        </h1>
                        <p>Use the steps below to configure your rule</p>

                        <FormSetupContext.Provider
                            value={{
                                id,
                                accountId,
                                activeStep,
                                setActiveStep,
                                stepsData,
                                setStepsData,
                                enrichmentType,
                                setEnrichmentList,
                                initStepsData,
                                setInitStepsData,
                                isPixelRule,
                            }}
                        >
                            <RuleType/>
                            <Conditions enrichmentType={enrichmentType} setAccountEnrichment={setAccountEnrichment} />
                            <NameDescription setAccountEnrichment={setAccountEnrichment} />
                        </FormSetupContext.Provider>
                    </div>
                )}
            </div>
        </React.Suspense>
    );
};

export default FormSetup;
